import { anatomyModule } from "./anatomy";
import { anatomy2Module } from "./anatomy2";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";
import { diseasesModule } from "./diseases";
import { pharmacologyModule } from "./pharmacology";
import { surgeryModule } from "./surgery";
import { surgery2Module } from "./surgery2";

export const adrenalglandModules = [anatomyModule, anatomy2Module, histologyModule, physiologyModule, diseasesModule, pharmacologyModule, surgeryModule, surgery2Module];
